import React, { ReactNode } from "react";
import styled from "styled-components";
import { content, prettyScrollbars } from "@glossy";
import { Locale } from "@linkfluence/models/locale";
import PopoverFooter from "./footer";

interface IProps {
  title?: string | ReactNode;
  onApply: () => void;
  onClear?: () => void;
  locale?: Locale;
  hasTitle?: boolean;
  children: ReactNode;
  disabled?: boolean;
  size?: "s" | "m" | "l";
  onCancel?: () => void;
  allowOverflow?: boolean;
  maxHeight?: number;
  validateLabel?: string;
  className?: string;
}

const Root = styled.div<{ size: IProps["size"] }>`
  width: ${({ size }) =>
    ({
      s: "480px",
      m: "750px",
      l: "1100px",
      auto: undefined,
    }[size || "auto"])};
  max-width: calc(100vw - 32px);
`;

const Header = styled.header`
  font-size: 18px;
  padding: 24px;
  border-bottom: 1px solid;
  border-color: ${(props) => content(props, "tertiary")};
  color: ${content};
`;

const Body = styled.div<{ allowOverflow?: boolean; maxHeight?: number }>`
  padding: 24px;
  // Leave a bottom spacing of 24px
  max-height: ${({ maxHeight }) =>
    maxHeight ? `${maxHeight}px` : `calc(100vh - 421px)`};
  ${prettyScrollbars};
  overflow-x: hidden;
  overflow-y: ${({ allowOverflow }) => (allowOverflow ? "visible" : "auto")};
  display: flex;
  flex-direction: column;
`;

const UiKitPopoverPanel = ({
  title,
  onApply,
  onClear,
  locale,
  hasTitle,
  children,
  disabled,
  size,
  onCancel,
  allowOverflow,
  maxHeight,
  validateLabel,
  className,
}: IProps) => (
  <Root size={size} className={className}>
    {hasTitle && <Header>{title}</Header>}
    <Body allowOverflow={allowOverflow} maxHeight={maxHeight}>
      {children}
    </Body>
    <PopoverFooter
      onApply={onApply}
      onCancel={onCancel}
      onClear={onClear}
      disabled={disabled}
      locale={locale}
    />
  </Root>
);

export default UiKitPopoverPanel;
